import * as React from 'react';

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { cn } from '@/lib/utils';
import type { Option as ComboboxOption } from './combobox';

export type Option<T extends string | null> = ComboboxOption<T>;

interface ComboboxAndPopoverProps {
  children: React.ReactNode;
  side?: 'left' | 'top' | 'right' | 'bottom' | undefined;
  align?: 'center' | 'start' | 'end' | undefined;
  open?: boolean;
  combobox: React.ReactNode;
  setOpen?: (open: boolean) => void;
  className?: string;
  onOpenAutoFocus?: (e: Event) => void;
}

export function ComboboxAndPopover({
  children,
  side,
  align,
  open,
  setOpen,
  combobox,
  className,
  onOpenAutoFocus,
}: ComboboxAndPopoverProps) {
  return (
    // DEV NOTE: modal={true} is required to allow ComboboxAndPopover to work
    // within dialogs see: https://github.com/shadcn-ui/ui/issues/1511#issuecomment-1810682366
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className={cn('w-[200px] p-0', className)}
        side={side}
        align={align}
        onOpenAutoFocus={onOpenAutoFocus}
      >
        {combobox}
      </PopoverContent>
    </Popover>
  );
}
